import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { motion } from 'framer-motion';

const AddBusiness = () => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    category: '',
    description: '',
    website: '',
  });
  const [logo, setLogo] = useState(null); // لتخزين ملف الصورة
  const [uploading, setUploading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // لتحديد إذا كانت النافذة المفتوحة
  const [croppedLogo, setCroppedLogo] = useState(null); // الصورة المقتصة
  const cropperRef = React.createRef(); // لربط المحصول

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogoChange = (e) => {
    setLogo(e.target.files[0]);
    setIsModalOpen(true); // فتح النافذة عند اختيار الصورة
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper; // الحصول على أداة القص
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas(); // استخراج الصورة المقتصة
      croppedCanvas.toBlob((blob) => {
        const file = new File([blob], logo.name, { type: logo.type });
        setCroppedLogo(file); // حفظ الصورة المقتصة كـ File
      });
    }
    setIsModalOpen(false); // إغلاق نافذة القص بعد اكتمال العملية
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    // التحقق من أن الحقول المطلوبة غير فارغة
    if (!formData.name || !formData.address || !formData.category) {
      alert("يرجى ملء جميع الحقول");
      setUploading(false);
      return;
    }

    try {
      let logoUrl = null;

      // إذا كانت الصورة المقتصة موجودة، قم برفعها إلى Supabase
      if (croppedLogo) {
        const { data, error } = await supabase.storage
          .from('logos') // اسم الحاوية
          .upload(`${Date.now()}_logo.${croppedLogo.type.split('/')[1]}`, croppedLogo, {
            contentType: croppedLogo.type, // تعيين نوع المحتوى
          });

        if (error) throw error;

        // الحصول على رابط الصورة
        logoUrl = `https://llmezmvrefvqmyoijcjk.supabase.co/storage/v1/object/public/logos/${data.path}`;
      }

      // إضافة البيانات إلى قاعدة البيانات
      const { error } = await supabase.from('businesses').insert([{ ...formData, logo_url: logoUrl }]);

      if (error) throw error;

      alert('تمت الإضافة بنجاح!');
      setFormData({ name: '', address: '', category: '', description: '', website: '' });
      setLogo(null);
      setCroppedLogo(null);
      setIsModalOpen(false);
    } catch (error) {
      alert('حدث خطأ أثناء الإضافة: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100" dir="rtl">
      <motion.form
        onSubmit={handleSubmit}
        className="w-full max-w-lg p-8 bg-white rounded-lg shadow-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-700">إضافة عمل جديد</h2>

        {/* حقل الاسم */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">الاسم <span className="text-red-500">*</span></label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            placeholder="أدخل اسم العمل"
          />
        </div>

        {/* حقل العنوان */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">العنوان <span className="text-red-500">*</span></label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            placeholder="أدخل العنوان"
          />
        </div>

        {/* حقل الفئة */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">الفئة <span className="text-red-500">*</span></label>
          <input
            type="text"
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            placeholder="أدخل الفئة"
          />
        </div>

        {/* حقل الوصف */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">الوصف</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            placeholder="أدخل وصف العمل"
          ></textarea>
        </div>

        {/* حقل الموقع الإلكتروني */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">الموقع الإلكتروني</label>
          <input
            type="text"
            name="website"
            value={formData.website}
            onChange={handleChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            placeholder="أدخل رابط الموقع"
          />
        </div>

        {/* حقل الشعار */}
        <div className="mb-4">
          <label className="block mb-2 text-sm font-medium text-gray-600">شعار العمل</label>
          <input
            type="file"
            onChange={handleLogoChange}
            className="w-full px-4 py-2 text-sm border rounded-md focus:ring focus:ring-indigo-200 focus:outline-none"
            accept="image/*"
          />
        </div>

        {/* زر الإرسال */}
        <motion.button
          type="submit"
          className={`w-full px-4 py-2 text-white bg-indigo-500 rounded-md hover:bg-indigo-600 focus:outline-none ${
            uploading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={uploading}
          whileHover={{ scale: 1.05 }}
        >
          {uploading ? 'جارٍ الإضافة...' : 'إضافة'}
        </motion.button>
      </motion.form>

      {/* نافذة القص */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <motion.div
            className="bg-white p-4 rounded-lg shadow-lg w-96"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <h3 className="mb-4 text-xl font-semibold">قص الشعار</h3>
            <Cropper
              ref={cropperRef}
              src={URL.createObjectURL(logo)}
              style={{ width: '100%', height: 400 }}
              aspectRatio={1} // المربع
              guides={false}
            />
            <div className="mt-4 flex justify-between">
              <button
                className="px-4 py-2 bg-gray-300 rounded-md"
                onClick={() => setIsModalOpen(false)} // إغلاق النافذة عند إلغاء
              >
                إلغاء
              </button>
              <button
                className="px-4 py-2 bg-indigo-500 text-white rounded-md"
                onClick={handleCrop} // قص الصورة وإغلاق النافذة
              >
                قص
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default AddBusiness;
